module.exports = __webpack_public_path__ + "assets/4363e2fba978f0789af0914565a1e904.mp3";